module.exports = __webpack_public_path__ + "img/ejj-wepublic.854bd358.png";